module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan4-1-7c6d687c5bfcdd04afd89b12dedd3210.webp";